import { Outlet, useLocation } from "@tanstack/react-router";
import { usePageDetector } from "hooks/usePageDetector";
import { cn } from "lib/cn";
import { trpc } from "lib/trpc";
import { Suspense, useEffect } from "react";
import { Header, HeaderUser } from "./Header";

export const Page = ({ isLoggedIn, user }: { isLoggedIn: boolean; user?: HeaderUser }) => {
    const { data: notifications } = trpc.notifications.latest.useQuery(undefined, {
        enabled: isLoggedIn,
    });
    const { isSocialPage, isLoginPage, isDiscussionPage } = usePageDetector();

    const location = useLocation();
    useEffect(() => {
        document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <div
            className={cn(
                "flex min-h-screen flex-col",
                isDiscussionPage && "max-h-screen overflow-auto",
            )}
        >
            <div className="flex grow flex-col text-slate-800">
                <Suspense fallback={<>Loading...</>}>
                    <Outlet />
                </Suspense>
            </div>
        </div>
    );
};
